<template>
	<div>
		<div class="headline">{{trackingNumber}}</div>

		<div class="subtitle-1 mt-3" v-if="result && result.status">
			{{formatTime(result.timeStamp)}}
			{{result.status}}
			{{result.detailedStatus}}
		</div>

		<div class="subtitle-1 mt-3" v-if="result && result.queuePosition > 0">
			Queued #{{result.queuePosition}} of {{result.queueLength}}
		</div>

		<v-row  v-if="result && active">
			<v-col>
				<v-switch
					v-model="refreshing"
					label="Auto Refresh (10 sec)"
					:loading="loading"
				></v-switch>
			</v-col>
		</v-row>

		<worker v-if="result.worker" :worker="result.worker"></worker>

		<v-card class="mt-5" v-if="result.jobStats">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title ><v-icon>fal fa-history fa-fw</v-icon> Job Stats</v-toolbar-title>
			</v-toolbar>
			<v-card-text>
				<job-stats :stats="[result.jobStats]" :type="result.transactionType" :created="result.created"></job-stats>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import worker from "../components/worker.vue";
import jobStats from "../components/jobstats/job-stats.vue";
import api from "../api";
import analysisApi from "../analysisApi";

// NOT USED

export default {
	components: {
		worker,
		jobStats,
	},
	data() {
		return {
			trackingNumber: null,
			token: null,
			interval: null,
			refreshing: true,
			result: {
				timeStamp: null,
				created: null,
				status: null,
				detailedStatus: null,
				queueLength: null,
				queuePosition: null,
				worker: null,
				jobStats: null,
			},
			active: true,
			loading: false,
		};
	},
	created() {
		this.trackingNumber = this.$route.params.trackingNumber;

		api.token(this.trackingNumber).then((r) => {
			this.token = r.data;
			analysisApi.setToken(this.token);
			this.startInterval();
			this.refresh();
		}, (e) => {
			this.showError(e);
		});
	},
	watch: {
		refreshing(v) {
			if (v) {
				this.startInterval();
			} else {
				this.stopInterval();
			}
		},
	},
	methods: {
		startInterval() {
			this.interval = setInterval(this.refresh, 10000);
		},
		stopInterval() {
			clearInterval(this.interval);
		},
		refresh() {
			this.loading = true;
			api.requestStatus(this.trackingNumber).then((r) => {
				this.result = r.data;
				this.loading = false;

				if (this.result.status === "Completed" || this.result.status === "Error" || this.result.status === "ErrorWillRetry") {
					this.refreshing = false;
					this.active = false;
				}
			}, (e) => {
				this.loading = false;
				this.showError(e);
			});
		},
	},
};
</script>
